var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar-container"},[_c('div',{staticClass:"bar",style:(_vm.barStyle)}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"votes"},[_vm._v(_vm._s(_vm.votesString))])])}
var staticRenderFns = []

export { render, staticRenderFns }